function PercentIconSVG() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8916 3.21826L2.6416 14.469L4.1386 15.966L15.3886 4.71601L13.8916 3.21826ZM5.26735 4.34326C5.07037 4.34306 4.87528 4.38167 4.69321 4.45687C4.51115 4.53207 4.34568 4.64239 4.20625 4.78154C4.06682 4.92069 3.95617 5.08594 3.88061 5.26785C3.80504 5.44976 3.76605 5.64478 3.76585 5.84176C3.76565 6.03874 3.80426 6.23384 3.87946 6.4159C3.95466 6.59797 4.06498 6.76343 4.20413 6.90286C4.34328 7.04229 4.50853 7.15294 4.69044 7.22851C4.87235 7.30407 5.06737 7.34306 5.26435 7.34326C5.66218 7.34366 6.04386 7.18601 6.32545 6.90498C6.60704 6.62396 6.76545 6.24259 6.76585 5.84476C6.76625 5.44694 6.6086 5.06525 6.32757 4.78366C6.04655 4.50208 5.66518 4.34366 5.26735 4.34326ZM12.7674 11.8433C12.3695 11.8429 11.9878 12.0005 11.7063 12.2815C11.4247 12.5626 11.2662 12.9439 11.2659 13.3418C11.2655 13.7396 11.4231 14.1213 11.7041 14.4029C11.9852 14.6844 12.3665 14.8429 12.7644 14.8433C12.9613 14.8435 13.1564 14.8049 13.3385 14.7297C13.5206 14.6545 13.686 14.5441 13.8255 14.405C13.9649 14.2658 14.0755 14.1006 14.1511 13.9187C14.2267 13.7368 14.2657 13.5417 14.2659 13.3448C14.266 13.1478 14.2274 12.9527 14.1522 12.7706C14.077 12.5886 13.9667 12.4231 13.8276 12.2837C13.6884 12.1442 13.5232 12.0336 13.3413 11.958C13.1593 11.8825 12.9643 11.8435 12.7674 11.8433Z"
        fill="#A3AED0"
      />
    </svg>
  );
}

export default PercentIconSVG;
